module.exports = __webpack_public_path__ + "logo_esdm-f4f251463ad280f3aafc4063cd0ee626.jpg";